export default "__VITE_ASSET__D2lTrwjw__"